import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { BodyMedium } from '@styled';

const CardStyled = styled.div`
    height: 200px;
    flex-grow: 1;
    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 15%);
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: ${props => `6px solid ${props.borderColor}`};
`;

const MemberRecognitionBlock = ({ recognitionString, borderColor }) => (
    <CardStyled className="mb-0" borderColor={borderColor}>
        <div className="p-4">
            <BodyMedium style={{ fontWeight: 'bold', textAlign: 'center' }}>{recognitionString}</BodyMedium>
        </div>
    </CardStyled>
);

MemberRecognitionBlock.propTypes = {
    recognitionString: PropTypes.string,
    borderColor: PropTypes.string,
};

export default MemberRecognitionBlock;
